// LAP-KAPU a partner-felületen: ha a jog a kiválasztott fiók-scope-ban nincs meg, a lap helyett magyarázat áll
// (nem összeomlás, nem 403-as lekérdezés). A keret-adat betöltéséig a gyerek NEM renderelődik — különben a
// lap egy garantáltan elutasított kérést indítana.
//
// A kapu CSAK UX: a fal a BFF-ben van (fiókonkénti jog minden végponton).
import type { PortalPermission } from '@atlas/shared';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { EmptyState } from '@/components/shared/empty-state';
import { usePortal } from '@/features/portal/portal-context';
import { usePortalPermissions } from '@/features/portal/use-portal-permissions';

export function PortalPermissionGate({
  permission,
  children,
}: {
  permission: PortalPermission;
  children: ReactNode;
}): JSX.Element | null {
  const { t } = useTranslation();
  const { accountId } = usePortal();
  const perms = usePortalPermissions();
  if (perms.isLoading) return null;
  if (!perms.hasInScope(permission, accountId)) {
    return (
      <EmptyState
        title={t('portal.noAccess.pageTitle')}
        description={t(
          accountId === null ? 'portal.noAccess.pageDesc' : 'portal.noAccess.scopeDesc',
        )}
      />
    );
  }
  return <>{children}</>;
}
